export default {
  title: {
    en: 'You are welcome',
  },
  text: {
    en: `
      You have successfully resubscribed to Scentbird.<br />
      Go to your profile to see your next shipping and billing info.
    `,
  },
}
